import { inject } from 'vue'
import { statisticsViewContextKey, type StatisticsViewContext } from './statistics-view-context'

export default function useStatisticsViewContext(): StatisticsViewContext {
  const statisticsViewContext = inject(statisticsViewContextKey)
  if (!statisticsViewContext) {
    throw new Error(
      'Statistics view context not found. Ensure this component is used within MonitoringView.',
    )
  }
  return statisticsViewContext
}
